import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=6a82cc46&"
import script from "./Gift.js?vue&type=script&lang=js&"
export * from "./Gift.js?vue&type=script&lang=js&"
import style0 from "./Gift.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Gift.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcart%2FGift%2FGift.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports